import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import { fetchUsersByDynamicSearch } from "../../services/ide-apis";
import { global_var } from "../../services/cs-lab-config";

const { Option } = Select;

const StudentLoader = ({ onChange, students }) => {
    document.title = 'Student Loader';
    const [users, setUsers] = useState([]);
    const [searchValue, setSearchValue] = useState('');
    const [loading, setLoading] = useState(false);
    const [debounceTimeout, setDebounceTimeout] = useState(null);

    const handleStudentSelect = (value, option) => {
        if (onChange && option && option.length > 0) {
            const dataToSendUser = option.map((opt) => {
                const { data: { fkUserLoginId, profile: { firstName } = {} } = {}, data: { Name } } = opt;
                return { fkUserLoginId, Name: firstName || Name };
            }).filter(Boolean);
            onChange(dataToSendUser);
        }
    };

    const handleSearchChange = (value) => {
        setSearchValue(value);

        // Clear the existing timeout
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }

        // Set a new timeout to trigger the API call after 500 milliseconds of inactivity
        const timeout = setTimeout(() => {
            fetchUsers();
        }, 500);

        setDebounceTimeout(timeout);
    };

    useEffect(() => {
        if (students && students.length > 0) {
            setUsers(students);
        }
    }, [students]);
    
    const fetchUsers = async () => {
        try {
            setLoading(true);

            const studentObj = {
                'teacherLoginId': global_var.user_login_id,
                'limitCount': 25,
                'skipCount': 0,
                projection: {
                    'userName': 1,
                    'profile.firstName': 1,
                    'profile.lastName': 1,
                    'fkUserLoginId': 1
                },
                searchKey: {
                    accountStatus: "Studying",
                    userName: searchValue,
                }
            };
            if (global_var.parent_company_id) {
                studentObj['childCompanyId'] = global_var.company_id;
                studentObj['companyId'] = global_var.parent_company_id;
            } else {
                studentObj['companyId'] = global_var.company_id;
                studentObj['searchKey']['showOnlyStudentInThisCompany'] = true;
            }

            const response = await fetchUsersByDynamicSearch(studentObj);

            if (response.data.statuscode === 200 && response.data.users.length > 0) {
                if (students && students.length > 0) {
                    const updatedUsers = [...students, ...response.data.users];
                    setUsers(updatedUsers);
                }else{
                    setUsers(response.data.users); 
                }
            } else {
                setUsers([]);
            }
        } catch (error) {
            console.error('Error fetching users:', error);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Select
                mode="multiple"
                placeholder="Search student here"
                style={{ width: '100%' }}
                onChange={handleStudentSelect}
                onSearch={handleSearchChange}
                optionLabelProp="label"
                showSearch
                filterOption={(input, option) => {
                    const label = option.label ? option.label.toLowerCase() : '';
                    const userName = option.data && option.data.userName ? option.data.userName.toLowerCase() : '';
                    const firstNameMatch = label.indexOf(input.toLowerCase()) >= 0;
                    const userNameMatch = userName.indexOf(input.toLowerCase()) >= 0;
                    return firstNameMatch || userNameMatch;
                }}
                loading={loading}
                value={students && students.map(student => student.Name)}
            >
                {users.map((user) => (
                    <Option key={user._id} value={user.profile?user.profile.firstName:user.Name} data={user} label={user.profile?user.profile.firstName:user.Name}>
                        {user.profile?user.profile.firstName:user.Name}
                    </Option>               
                ))}
            </Select>
        </div>
    );
};

export default StudentLoader;
